import {DeviceAvdbType} from "./device-avdb-type";
import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";

export class JeppAvdbTypeResponse extends JSONMapped() {
	@jsonProperty()
	deviceModelId: number;

	@jsonProperty(JSONMapper.arrayOfClass(DeviceAvdbType))
	avdbTypes: Array<DeviceAvdbType>;

	constructor(data?: Partial<JeppAvdbTypeResponse>) {
		super();
		Object.assign(this, data);
	}

	equals(other: JeppAvdbTypeResponse) {
		return this.deviceModelId === other.deviceModelId;
	}
}
